<template>
  <!-- 物联网卡=》设备管理 -->
  <div id="trafficMagtIndex" class="containerWarp">
    <!-- 筛选 -->
    <div class="searchWarp">
      <div class="searchBox dateBox">
        <el-date-picker v-model="selectDayWarning" :end-placeholder="$t('AllDevices.endDate')" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" type="daterange" @change="changeSearch('date')" />
      </div>
      <el-select v-model="searchObj.status" :placeholder="$t('AllDevices.Status')" class="filter-item tableSelect Status" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in statusOptions" :key="index" :label="item.label" :value="item.value" />
      </el-select>
      <SearchCompany v-model="selectCompany2" :value="selectCompany2" @change="changeSearch" />
      <el-input v-model="searchObj.key" :placeholder="$t('dashboard.DeviceName')+'/'+$t('BondOrUpdateDevice.SN')" class="input-with-select tableSelect" clearable @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <!-- 服务赠送时长 -->
      <el-select v-model="searchObj.giftDuration" :placeholder="$t('table1.service_gift_time')" class="filter-item tableSelect" clearable filterable @change="changeSearch">
        <el-option v-for="(item,index) in giftOptions" :key="index" :label="item.label" :value="item.value" />
      </el-select>
    </div>
    <!-- 表格 -->
    <el-table id="feedBackTable" v-loading="loading" :data="tableList" style="width: 100%" border fit highlight-current-row>
      <el-table-column prop="sn" :label="$t('BondOrUpdateDevice.SN')" align="center" />
      <el-table-column prop="deviceName" :label="$t('dashboard.DeviceName')" align="center">
        <template slot-scope="scope">
          <div style="text-align: center;">
            <el-link style="margin-right: 10px;" type="primary" @click="goToDetail(scope.row)">{{ scope.row.deviceName }}</el-link>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="companyName" :label="$t('AllDevices.companyName')" align="center" />
      <el-table-column prop="activeTimeZh" :label="$t('allDeviceDetail.ActivationTime')" align="center" />
      <el-table-column prop="serviceEndTimeZh" :label="$t('sim.serviceEndTime')" align="center">
        <template slot-scope="scope">
          <div style="text-align: center;">
            <el-button v-if="scope.row.overtime" size="mini" type="danger" plain style="padding: 1px 7px;position: absolute;top: 1px;left: 1px;">{{ $t('feedBack.expired') }}</el-button>
            <p>{{ scope.row.serviceEndTimeZh }}</p>
          </div>
        </template>
      </el-table-column>
      <!-- 服务赠送时长 -->
      <el-table-column prop="giftDuration" :label="$t('table1.service_gift_time')" align="center">
        <template slot-scope="scope">
          {{ scope.row.giftDuration }} {{ $t('sim.year') }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="planName" :label="$t('sim.PackageName')" align="center" /> -->
      <el-table-column prop="areaListStr" :label="$t('sim.UseArea')" align="center" show-overflow-tooltip min-width="140px">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.areaListStr }}</span>
            <i v-if="scope.row.areaAbnormal" class="el-icon-warning-outline" :title="$t('sim.UseAreaAbnormal')" />
          </div>

        </template>
      </el-table-column>
    </el-table>
    <!-- 列表模块————分页 -->
    <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
      <div class="pagination-container">
        <el-pagination
          v-if="pageshow"
          background
          current-page.sync="listQuery.pageInfo.page"
          :page-sizes="listQuery.pageInfo.pageList"
          :page-size="listQuery.pageInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.pageInfo.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { pageDeviceInfo } from '@/api/sim'
import { pagination } from '@/utils/init_table' // 分页
import i18n from '@/i18n'
import { getDateAndHour } from '@/utils/updateTime.js'
import { listByCompanyParentId } from '@/api/allDevice'

import { arrObjSort } from '@/utils/arrayFun.js'
import vPinyin from '@/utils/pinyin-vue.js'
export default {
  components: {

  },
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      searchObj: {
        key: null,
        status: null,
        companyId: '',
        giftDuration: ''
      },
      selectDayWarning: [],
      tableList: [],
      loading: true,
      selectCompany: [],
      selectCompany2: []
    }
  },
  computed: {
    statusOptions() { // 是否在有效期内。0过期，1有效，2未激活
      return [
        { label: i18n.t('sim.effective'), value: 1 },
        { label: i18n.t('sim.Expired'), value: 0 },
        { label: i18n.t('adminView.NotActivated'), value: 2 }
      ]
    },
    language() {
      return this.$store.state.language
    },
    giftOptions() {
      return [
        { label: '1' + this.$t('sim.year'), value: 1 },
        { label: '2' + this.$t('sim.year'), value: 2 },
        { label: '3' + this.$t('sim.year'), value: 3 }
      ]
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.initTable() // 初始化列表
    }
  },
  mounted() {
    this.initTable()// 获取区域/洲和国家/地区级联列表
  },
  methods: {
    initTable() { // 初始化列表
      this.loading = true
      var param = {
        'key': this.searchObj.key,
        'status': this.searchObj.status,
        'companyIdList': this.selectCompany,
        'pageNum': this.listQuery.pageInfo.pageNum,
        'pageSize': this.listQuery.pageInfo.pageSize,
        giftDuration: this.searchObj.giftDuration
      }
      if (this.selectDayWarning && this.selectDayWarning.length > 0) {
        param.startTime = new Date(this.selectDayWarning[0]).setHours(0, 0, 0, 0)
        param.endTime = new Date(this.selectDayWarning[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      pageDeviceInfo(param).then(res => {
        console.log('设备管理列表：', res)
        this.loading = false
        if (res.resultCode == 1001) {
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          this.tableList = res.resultModel.list || []
          this.tableList.forEach(v => {
            v.overtime = false
            if (v.activeTime)v.activeTimeZh = getDateAndHour(v.activeTime, 'noTime')
            if (v.serviceEndTime) {
              // v.serviceEndTime = 1650349104636
              v.serviceEndTimeZh = getDateAndHour(v.serviceEndTime, 'noTime')
              if (Date.now() > v.serviceEndTime)v.overtime = true
            }
            var areaList = v.regionInfo || {}
            v.areaListStr = this.$store.state.language == 'zh' ? areaList.countryName : areaList.countryNameEn
          })
        }
      })
    },
    goToDetail(row) {
      var routeData = this.$router.resolve({
        path: '/sim/deviceDetail',
        query: {
          mcuId: row.mcuId
        }
      })
      sessionStorage.setItem('deviceMagtRow', JSON.stringify(row))
      window.open(routeData.href, '_self')
    },
    changeSearch() {
      this.selectCompany = []
      this.selectCompany2.forEach(v => {
        this.selectCompany.push((typeof v === 'string' && v.indexOf('ID') > -1) ? v.slice(2) : v)
      })
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.initTable()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.initTable()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.initTable()
    }
  }
}
</script>

<style lang="scss">
#trafficMagtIndex{
  .searchWarp{
    margin-bottom:20px;
    display:flex;
    position:relative;
    .tableSelect{
      width:20%;
      &.Status{
        width:10%;
      }
    }
    .dateBox{
      margin-left: 5px;
    }

  }
  .el-icon-warning-outline{
    color:red;
    padding:5px;
  }
}

</style>
